// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/img/rhombuztext.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  width: 50%;
  display: inline-block;
  justify-content: flex-start;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 0 0;
  background-size: auto 100%;
  padding-left: 25px;
  height: 2em;
  cursor: pointer;
}
nav {
  display: flex;
  position: fixed;
  -webkit-transition: all 0.5s;
  width: 100%;
  padding: 2em 5em;
  box-sizing: border-box;
  color: white;
  background-size: 100%;
  z-index: 50;
}
.nav.web-only li {
  font-weight: 400;
  transition: transform 0.3s;
}

nav ul {
  width: 50%;
  justify-content: flex-end;
  font-weight: 200;
}
.test {
  background-color: #131313;
}
.none {
  background: transparent;
}

.roll-downheader {
  transform: translate(0, 0px);
  padding: 1.2em 5em;
  background-color: rgba(0, 0, 0, 0.4);
}
.roll-upheader {
  transform: translate(0, -200px);
}

@media only screen and (min-width: 760px) {
  .centraltext {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 2% 40%;
    background-size: 18%;
    height: 2em;
    width: 100%;
  }
}
@media only screen and (max-width: 760px) {
  nav {
    padding: 1.5em;
    background-color: #131313;
  }
  #menuToggle {
    display: block;
    position: relative;
    top: 10px;
    left: 30%;

    z-index: 1;

    -webkit-user-select: none;
    user-select: none;
  }

  #menuToggle a {
    text-decoration: none;
    color: #fff;

    transition: color 0.3s ease;
  }

  #menuToggle a:hover {
    color: tomato;
  }

  #menuToggle input {
    display: block;
    width: 40px;
    height: 32px;
    position: absolute;
    top: -7px;
    left: -5px;

    cursor: pointer;

    opacity: 0; /* hide this */
    z-index: 2; /* and place it over the hamburger */

    -webkit-touch-callout: none;
  }

  /*
 * Just a quick hamburger
 */
  #menuToggle span {
    display: block;
    width: 33px;
    height: 2px;
    margin-bottom: 5px;
    position: relative;

    background: #cdcdcd;
    border-radius: 3px;

    z-index: 1;

    transform-origin: 4px 0px;

    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
      background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease;
  }

  #menuToggle span:first-child {
    transform-origin: 0% 0%;
  }

  #menuToggle span:nth-last-child(2) {
    transform-origin: 0% 100%;
  }

  /* 
 * Transform all the slices of hamburger
 * into a crossmark.
 */
  #menuToggle input:checked ~ span {
    opacity: 1;
    transform: rotate(45deg) translate(-2px, -2px);
    background: #fff;
  }

  /*
 * But let's hide the middle one.
 */
  #menuToggle input:checked ~ span:nth-last-child(3) {
    opacity: 0;
    transform: rotate(0deg) scale(0.2, 0.2);
  }

  /*
 * Ohyeah and the last one should go the other direction
 */
  #menuToggle input:checked ~ span:nth-last-child(2) {
    transform: rotate(-45deg) translate(-1px, 2px);
  }

  /*
 * Make this absolute positioned
 * at the top left of the screen
 */
  #menu {
    position: absolute;
    width: 100vw;
    top: -5em;
    padding: 35vh 35px;
    padding-top: 40vh;
    box-sizing: border-box;
    left: 50vw;
    height: 110vh;
    background: #131313;
    color: #fff;
    list-style-type: none;
    -webkit-font-smoothing: antialiased;
    /* to stop flickering of text in safari */
    flex-direction: column;
    transform-origin: 0% 0%;
    transform: none;

    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1);
  }

  #menu li {
    padding: 10px 0;
    font-size: 32px;
    font-weight: 600;
    text-align: right;
  }

  /*
 * And let's slide it in from the left
 */
  #menuToggle input:checked ~ ul {
    transform: translate(-132.2%, 0);
  }
  .roll-downheader {
    padding: 1.5em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/header/header.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,qBAAqB;EACrB,2BAA2B;EAC3B,iEAAwD;EACxD,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,oEAAkE;IAClE,oBAAoB;IACpB,WAAW;IACX,WAAW;EACb;AACF;AACA;EACE;IACE,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,SAAS;;IAET,UAAU;;IAEV,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,WAAW;;IAEX,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;;IAEV,eAAe;;IAEf,UAAU,EAAE,cAAc;IAC1B,UAAU,EAAE,oCAAoC;;IAEhD,2BAA2B;EAC7B;;EAEA;;EAEA;EACA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,kBAAkB;;IAElB,mBAAmB;IACnB,kBAAkB;;IAElB,UAAU;;IAEV,yBAAyB;;IAEzB;0EACsE;EACxE;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;;EAGA;EACA;IACE,UAAU;IACV,8CAA8C;IAC9C,gBAAgB;EAClB;;EAEA;;EAEA;EACA;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;;EAEA;EACA;IACE,8CAA8C;EAChD;;EAEA;;;EAGA;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,mCAAmC;IACnC,yCAAyC;IACzC,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;;IAEf,2DAA2D;EAC7D;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;EAEA;EACA;IACE,gCAAgC;EAClC;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":[".logo {\n  width: 50%;\n  display: inline-block;\n  justify-content: flex-start;\n  background: url(../../assets/img/logo.svg) no-repeat 0 0;\n  background-size: auto 100%;\n  padding-left: 25px;\n  height: 2em;\n  cursor: pointer;\n}\nnav {\n  display: flex;\n  position: fixed;\n  -webkit-transition: all 0.5s;\n  width: 100%;\n  padding: 2em 5em;\n  box-sizing: border-box;\n  color: white;\n  background-size: 100%;\n  z-index: 50;\n}\n.nav.web-only li {\n  font-weight: 400;\n  transition: transform 0.3s;\n}\n\nnav ul {\n  width: 50%;\n  justify-content: flex-end;\n  font-weight: 200;\n}\n.test {\n  background-color: #131313;\n}\n.none {\n  background: transparent;\n}\n\n.roll-downheader {\n  transform: translate(0, 0px);\n  padding: 1.2em 5em;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.roll-upheader {\n  transform: translate(0, -200px);\n}\n\n@media only screen and (min-width: 760px) {\n  .centraltext {\n    background: url(../../assets/img/rhombuztext.png) no-repeat 2% 40%;\n    background-size: 18%;\n    height: 2em;\n    width: 100%;\n  }\n}\n@media only screen and (max-width: 760px) {\n  nav {\n    padding: 1.5em;\n    background-color: #131313;\n  }\n  #menuToggle {\n    display: block;\n    position: relative;\n    top: 10px;\n    left: 30%;\n\n    z-index: 1;\n\n    -webkit-user-select: none;\n    user-select: none;\n  }\n\n  #menuToggle a {\n    text-decoration: none;\n    color: #fff;\n\n    transition: color 0.3s ease;\n  }\n\n  #menuToggle a:hover {\n    color: tomato;\n  }\n\n  #menuToggle input {\n    display: block;\n    width: 40px;\n    height: 32px;\n    position: absolute;\n    top: -7px;\n    left: -5px;\n\n    cursor: pointer;\n\n    opacity: 0; /* hide this */\n    z-index: 2; /* and place it over the hamburger */\n\n    -webkit-touch-callout: none;\n  }\n\n  /*\n * Just a quick hamburger\n */\n  #menuToggle span {\n    display: block;\n    width: 33px;\n    height: 2px;\n    margin-bottom: 5px;\n    position: relative;\n\n    background: #cdcdcd;\n    border-radius: 3px;\n\n    z-index: 1;\n\n    transform-origin: 4px 0px;\n\n    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),\n      background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease;\n  }\n\n  #menuToggle span:first-child {\n    transform-origin: 0% 0%;\n  }\n\n  #menuToggle span:nth-last-child(2) {\n    transform-origin: 0% 100%;\n  }\n\n  /* \n * Transform all the slices of hamburger\n * into a crossmark.\n */\n  #menuToggle input:checked ~ span {\n    opacity: 1;\n    transform: rotate(45deg) translate(-2px, -2px);\n    background: #fff;\n  }\n\n  /*\n * But let's hide the middle one.\n */\n  #menuToggle input:checked ~ span:nth-last-child(3) {\n    opacity: 0;\n    transform: rotate(0deg) scale(0.2, 0.2);\n  }\n\n  /*\n * Ohyeah and the last one should go the other direction\n */\n  #menuToggle input:checked ~ span:nth-last-child(2) {\n    transform: rotate(-45deg) translate(-1px, 2px);\n  }\n\n  /*\n * Make this absolute positioned\n * at the top left of the screen\n */\n  #menu {\n    position: absolute;\n    width: 100vw;\n    top: -5em;\n    padding: 35vh 35px;\n    padding-top: 40vh;\n    box-sizing: border-box;\n    left: 50vw;\n    height: 110vh;\n    background: #131313;\n    color: #fff;\n    list-style-type: none;\n    -webkit-font-smoothing: antialiased;\n    /* to stop flickering of text in safari */\n    flex-direction: column;\n    transform-origin: 0% 0%;\n    transform: none;\n\n    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1);\n  }\n\n  #menu li {\n    padding: 10px 0;\n    font-size: 32px;\n    font-weight: 600;\n    text-align: right;\n  }\n\n  /*\n * And let's slide it in from the left\n */\n  #menuToggle input:checked ~ ul {\n    transform: translate(-132.2%, 0);\n  }\n  .roll-downheader {\n    padding: 1.5em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
